export default {
  getDashboardConfig: (state) => state.dashboardConfig || {},
  getDashboardList: (state) => state.dashboardList || [],
  getDefaultDashboard: (state) => state.defaultDashboard,
  getSelectedDashboard: (state) => state.selectedDashboard,
  getDashboardLoading: (state) => state.dashboardLoading || {},
  getDashboards: (state) => state.dashboards || [],
  getDashboardItems: (state) => (type) =>
    (state.dashboardItems || {})[type] || [],
};
